"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CornerRadii = void 0;
exports.CornerRadii = {
    "radius-1": "4px",
    "radius-2": "8px",
    "radius-3": "12px",
    "radius-4": "16px",
    "radius-5": "100px"
};
//# sourceMappingURL=CornerRadii.js.map